export const VALIDATION_ERROR_EMAIL_IS_INVALID =
  'VALIDATION_ERROR_EMAIL_IS_INVALID'
export const VALIDATION_ERROR_IS_REQUIRED = 'VALIDATION_ERROR_IS_REQUIRED'

export const VALIDATION_ERROR_FRIENDLY_CAPTCHA_FAILED =
  'VALIDATION_ERROR_FRIENDLY_CAPTCHA_FAILED'

export const VALIDATION_ERROR_MIN_VALUE = 'VALIDATION_ERROR_MIN_VALUE'

export const VALIDATION_ERROR_MIN_MAX_VALUE = 'VALIDATION_ERROR_MIN_MAX_VALUE'
